"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmailTemplate = void 0;
const react_1 = __importStar(require("react"));
const client_1 = require("@apollo/client");
const react_hook_form_1 = require("react-hook-form");
const zod_1 = require("@hookform/resolvers/zod");
const react_router_dom_1 = require("react-router-dom");
const lodash_1 = require("lodash");
const polaris_1 = require("@shopify/polaris");
const AccountContext_1 = require("contexts/AccountContext");
const components_1 = require("@/common/components");
const LoadingSpinner_1 = __importDefault(require("components/general/LoadingSpinner"));
const hooks_1 = require("@/common/hooks");
const nice_modal_react_1 = __importDefault(require("@ebay/nice-modal-react"));
const errors_copy_1 = require("@/common/errors.copy");
const common_1 = require("@/emails/common");
const components_2 = require("@/emails/common/components");
const layout_1 = require("@/common/components/layout");
const text_1 = require("@/common/components/text");
const email_template_validation_1 = require("./email-template.validation");
const email_template_copy_1 = require("./email-template.copy");
const use_email_template_hook_1 = require("./use-email-template.hook");
const email_template_graphql_1 = require("./email-template.graphql");
const helpers_1 = require("@/common/helpers");
const polaris_icons_1 = require("@shopify/polaris-icons");
const EmailTemplate = () => {
    var _a, _b;
    const { account } = (0, AccountContext_1.useAccount)();
    const { pathname } = (0, react_router_dom_1.useLocation)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const { emailTypes, emailTypesLoading, emailTypesError, refetchEmailTypes } = (0, common_1.useEmailTypesContext)();
    const { config } = (0, common_1.useTransactionalEmailConfig)();
    const currentSlug = pathname.split('/')[2];
    nice_modal_react_1.default.register('send-test-email-modal', components_2.SendTestEmailModal);
    const [activeTemplateType, setActiveTemplateType] = (0, react_1.useState)(undefined);
    const [showLeaveModal, setShowLeaveModal] = (0, react_1.useState)(false);
    const [errorBanner, setErrorBanner] = (0, react_1.useState)(null);
    const [disableSendTestEmailButton, setDisableSendTestEmailButton] = (0, react_1.useState)(true);
    const [successBanner, setSuccessBanner] = (0, react_1.useState)(null);
    const [imageUploadError, setImageUploadError] = (0, react_1.useState)();
    const [disableEmailActivation, setDisableEmailActivation] = (0, react_1.useState)(true);
    const [showPendingBanner, setShowPendingBanner] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        const alreadyActivated = (activeTemplateType === null || activeTemplateType === void 0 ? void 0 : activeTemplateType.active) === true;
        const noTrackingPage = !(account === null || account === void 0 ? void 0 : account.defaultTrackingPageUrl);
        if (!noTrackingPage || (noTrackingPage && alreadyActivated)) {
            setDisableEmailActivation(false);
        }
        if (noTrackingPage && !alreadyActivated) {
            setDisableEmailActivation(true);
        }
    }, [account === null || account === void 0 ? void 0 : account.defaultTrackingPageUrl, activeTemplateType === null || activeTemplateType === void 0 ? void 0 : activeTemplateType.active]);
    (0, react_1.useEffect)(() => {
        var _a, _b;
        const emailVerified = (_a = account === null || account === void 0 ? void 0 : account.primaryHostedDomain) === null || _a === void 0 ? void 0 : _a.emailVerified;
        const isPendingEmailVerification = !emailVerified &&
            ((_b = account === null || account === void 0 ? void 0 : account.primaryHostedDomain) === null || _b === void 0 ? void 0 : _b.emailDomainVerificationStatus) === 'pending';
        emailVerified
            ? setDisableSendTestEmailButton(false)
            : setDisableSendTestEmailButton(true);
        isPendingEmailVerification
            ? setShowPendingBanner(true)
            : setShowPendingBanner(false);
    }, [
        (_a = account === null || account === void 0 ? void 0 : account.primaryHostedDomain) === null || _a === void 0 ? void 0 : _a.emailVerified,
        (_b = account === null || account === void 0 ? void 0 : account.primaryHostedDomain) === null || _b === void 0 ? void 0 : _b.emailDomainVerificationStatus
    ]);
    const DEFAULT_VALUES = {
        active: false,
        subject: '',
        imageBannerUrl: '',
        imageBannerLink: '',
        heading: '',
        body: '',
        footer: 'If you have any questions, contact us at [{{reply_to_email}}](mailto:{{reply_to_email}})'
    };
    const { error: emailTemplateFetchError, data: emailTemplateData, refetch: refetchEmailTemplate, loading: isEmailTemplateLoading } = (0, use_email_template_hook_1.useEmailTemplate)(currentSlug);
    (0, react_1.useEffect)(() => {
        if (emailTypes.length > 0) {
            const templateDetails = emailTypes.find((type) => type.slug === currentSlug);
            if (!templateDetails) {
                navigate('/transactional_emails');
                return;
            }
            setActiveTemplateType(templateDetails);
        }
    }, [emailTypes, emailTemplateData]);
    const { control, formState: { isDirty, isValid, errors, isValidating }, handleSubmit, reset, setValue, setError, watch } = (0, react_hook_form_1.useForm)({
        mode: 'onChange',
        defaultValues: DEFAULT_VALUES,
        resolver: (0, zod_1.zodResolver)(email_template_validation_1.formSchema)
    });
    const isTemplateActive = watch('active');
    const imageBannerUrl = watch('imageBannerUrl');
    (0, hooks_1.useConfirmFormLeave)({ isFormDirty: isDirty });
    (0, react_1.useEffect)(() => {
        hideServerBanners();
    }, [isValidating]);
    const [createAssetUploadUrl] = (0, client_1.useMutation)(email_template_graphql_1.CREATE_ASSET_UPLOAD_URL, {
        onError(_error) {
            setImageUploadError('There was an issue uploading the banner image. Please try again.');
        }
    });
    const [updateEmailTemplate, { loading: loadingUpdate }] = (0, client_1.useMutation)(email_template_graphql_1.UPDATE_EMAIL_TEMPLATE, {
        onCompleted: () => {
            setSuccessBanner(email_template_copy_1.EMAIL_TEMPLATE_COPY.emailTemplateUpdateSuccess);
            setErrorBanner(null);
            // Refetch to update default discard/reset values
            refetchEmailTemplate();
            refetchEmailTypes();
        },
        onError(error) {
            var _a;
            setSuccessBanner(null);
            const formattedErrors = (0, helpers_1.formatGraphqlErrors)(error);
            formattedErrors.forEach((errorDetail) => {
                setError(errorDetail[0], errorDetail[1]);
            });
            // setError updates the errors object
            ((_a = errors.root) === null || _a === void 0 ? void 0 : _a.serverError)
                ? setErrorBanner(email_template_copy_1.EMAIL_TEMPLATE_COPY.generalServerError)
                : setErrorBanner(email_template_copy_1.EMAIL_TEMPLATE_COPY.emailTemplateFormValidationErrors);
        }
    });
    const handleShowSendTestEmailModal = (0, react_1.useCallback)(() => __awaiter(void 0, void 0, void 0, function* () {
        try {
            hideServerBanners();
            const modalResponse = yield nice_modal_react_1.default.show('send-test-email-modal', {
                template: currentSlug
            });
            setSuccessBanner(modalResponse.message);
        }
        catch (err) {
            setErrorBanner(`${err}`);
        }
    }), []);
    const onSubmit = (updatedEmailTemplateData) => {
        setErrorBanner(null);
        if (!account) {
            throw new Error('No account selected');
        }
        updateEmailTemplate({
            variables: {
                input: Object.assign(Object.assign({}, updatedEmailTemplateData), { accountId: account.id, notificationTypeSlug: currentSlug })
            }
        });
    };
    const values = watch();
    (0, react_1.useEffect)(() => {
        resetToConfigDefaults();
    }, [emailTemplateData]);
    function resetToConfigDefaults() {
        if (!emailTemplateData) {
            // Config response is successful but we receive null
            reset(DEFAULT_VALUES);
            return;
        }
        // Use available config values if available or set to default
        const formValues = (0, lodash_1.mergeWith)({}, DEFAULT_VALUES, emailTemplateData, (defaultValue, updatedValue) => updatedValue === null ? defaultValue : undefined);
        reset(formValues);
    }
    function handleCheckboxToggle() {
        setValue('active', !isTemplateActive);
    }
    function handleRemoveImageUrl() {
        setValue('imageBannerUrl', '');
    }
    function hideServerBanners() {
        if (errorBanner || successBanner) {
            setErrorBanner(null);
            setSuccessBanner(null);
        }
    }
    function renderAccountVerificationBanner() {
        if (showPendingBanner) {
            return (react_1.default.createElement(polaris_1.Layout.Section, { variant: 'fullWidth' },
                react_1.default.createElement(polaris_1.Banner, { icon: polaris_icons_1.ClockIcon, tone: 'warning' },
                    react_1.default.createElement("p", { id: 'account-verification-page-banner' }, email_template_copy_1.EMAIL_TEMPLATE_COPY.verificationProcessingMsg))));
        }
        return null;
    }
    function handleImageUpload(file) {
        return __awaiter(this, void 0, void 0, function* () {
            const logoErrorMsg = 'There was an issue uploading the banner image. Please try again.';
            hideServerBanners();
            if (!file) {
                return;
            }
            if (!account) {
                throw new Error('No account selected');
            }
            setImageUploadError(undefined);
            const fileExt = file.type.split('/').pop();
            const result = yield createAssetUploadUrl({
                variables: {
                    input: {
                        accountId: account.id,
                        filename: `banner.${fileExt}`
                    }
                }
            });
            if (!result.data) {
                setImageUploadError(logoErrorMsg);
                return;
            }
            const { publicUrl, url, version } = result.data.createTransactionalEmailAssetUploadUrl;
            const uploadResult = yield fetch(url, {
                mode: 'cors',
                method: 'PUT',
                headers: {
                    'Content-Type': 'image/png',
                    'x-amz-meta-malomo-version': `${version}`
                },
                body: file
            });
            if (!uploadResult.ok) {
                const { status, statusText } = uploadResult;
                setImageUploadError(`${status} ${statusText}: ${logoErrorMsg}`);
                return;
            }
            setImageUploadError(undefined);
            setValue('imageBannerUrl', publicUrl);
        });
    }
    function handlePageBackButtonPressed() {
        if (!isDirty) {
            navigate('/transactional_emails');
            return;
        }
        setShowLeaveModal(true);
    }
    function handleCloseFormLeaveModal() {
        setShowLeaveModal(false);
    }
    function handleSkipFormLeaveModal() {
        navigate('/transactional_emails');
    }
    if (emailTypesError || emailTemplateFetchError) {
        return renderServerErrorBanner();
    }
    if (isEmailTemplateLoading || emailTypesLoading) {
        return (react_1.default.createElement(layout_1.PolarisPage, null,
            react_1.default.createElement(polaris_1.Layout, null,
                react_1.default.createElement(LoadingSpinner_1.default, null))));
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(components_1.FormLeaveModal, { active: showLeaveModal, onClose: handleCloseFormLeaveModal, onSkipWarning: handleSkipFormLeaveModal }),
        react_1.default.createElement(polaris_1.Form, { noValidate: true, onSubmit: handleSubmit(onSubmit) },
            react_1.default.createElement(layout_1.PolarisPage, { backAction: { onAction: handlePageBackButtonPressed }, fullWidth: true, primaryAction: react_1.default.createElement(polaris_1.Button, { disabled: !isValid, id: 'email-template-save-button', loading: loadingUpdate, submit: true, variant: 'primary' }, "Save"), secondaryActions: react_1.default.createElement(polaris_1.Button, { disabled: disableSendTestEmailButton, id: 'email-template-send-test-button', onClick: handleShowSendTestEmailModal }, "Send test"), subtitle: activeTemplateType === null || activeTemplateType === void 0 ? void 0 : activeTemplateType.description, title: `'${activeTemplateType === null || activeTemplateType === void 0 ? void 0 : activeTemplateType.name}' Email`, titleMetadata: renderActiveBadge() },
                react_1.default.createElement(polaris_1.BlockStack, { gap: '400' },
                    renderBanner(),
                    react_1.default.createElement(polaris_1.Layout, null,
                        renderAccountVerificationBanner(),
                        react_1.default.createElement(polaris_1.Layout.Section, { variant: 'oneHalf' },
                            react_1.default.createElement(polaris_1.Layout, null,
                                react_1.default.createElement(polaris_1.Layout.Section, null, renderActiveCard()),
                                react_1.default.createElement(polaris_1.Layout.Section, null, renderMainCard()))),
                        react_1.default.createElement(polaris_1.Layout.Section, { variant: 'oneHalf' },
                            react_1.default.createElement(common_1.EmailPreview, { config: config, notificationTypeSlug: currentSlug, template: values }))))))));
    // Replaces the page when default config values can't be obtained
    function renderServerErrorBanner() {
        return (react_1.default.createElement(layout_1.PolarisPage, null,
            react_1.default.createElement("div", { id: 'email-template-default-values-error' },
                react_1.default.createElement(polaris_1.Banner, { title: 'Cannot load email template configuration.', tone: 'critical' }, errors_copy_1.errorsCopy.fetchError))));
    }
    function renderActiveBadge() {
        return (react_1.default.createElement(polaris_1.Badge, { tone: (activeTemplateType === null || activeTemplateType === void 0 ? void 0 : activeTemplateType.active) ? 'success' : 'new' }, (activeTemplateType === null || activeTemplateType === void 0 ? void 0 : activeTemplateType.active) ? 'Live' : 'Inactive'));
    }
    function renderBanner() {
        if (errorBanner) {
            return (react_1.default.createElement(polaris_1.Banner, { onDismiss: hideServerBanners, title: errorBanner, tone: 'critical' }));
        }
        if (successBanner) {
            return (react_1.default.createElement(polaris_1.Banner, { onDismiss: hideServerBanners, title: successBanner, tone: 'success' }));
        }
        return undefined;
    }
    function renderShopifyPlusWarning() {
        if (activeTemplateType === null || activeTemplateType === void 0 ? void 0 : activeTemplateType.shopifyPlus) {
            return (react_1.default.createElement(polaris_1.Text, { as: 'p', id: 'email-template-shopify-plus-warning', tone: 'critical', variant: 'bodySm' },
                `
          You should only set this email to 'live' if your store is on Shopify
          Plus, and you've contacted your Shopify representative to disable the
          default Shopify '${activeTemplateType === null || activeTemplateType === void 0 ? void 0 : activeTemplateType.name}' email. `,
                react_1.default.createElement(polaris_1.Link, { removeUnderline: true, target: '_blank', url: 'https://help.gomalomo.com/csc/how-to-disable-shopify-notification-emails' }, "Learn more")));
        }
        return null;
    }
    function renderActiveHelpText() {
        return (react_1.default.createElement(polaris_1.BlockStack, { gap: '200' },
            react_1.default.createElement(polaris_1.Text, { as: 'p', id: 'default-tracking-page-required-msg', tone: 'base', variant: 'bodySm' },
                "A\u00A0",
                react_1.default.createElement(polaris_1.Link, { removeUnderline: true, target: '_blank', url: '/account' }, "default tracking page"),
                "\u00A0 must be configured before emails can be sent."),
            renderShopifyPlusWarning()));
    }
    function renderActiveCard() {
        return (react_1.default.createElement(polaris_1.Card, null,
            react_1.default.createElement(polaris_1.BlockStack, { gap: '300' },
                react_1.default.createElement(react_hook_form_1.Controller, { control: control, name: 'active', render: ({ field: { value, ref: _ref } }) => (react_1.default.createElement(polaris_1.Checkbox, { checked: value, disabled: disableEmailActivation, helpText: renderActiveHelpText(), id: 'email-template-active-checkbox', label: react_1.default.createElement(polaris_1.Text, { as: 'span' },
                            "'", activeTemplateType === null || activeTemplateType === void 0 ? void 0 :
                            activeTemplateType.name,
                            "' email is",
                            react_1.default.createElement(polaris_1.Text, { as: 'span', fontWeight: 'bold' }, value ? ' Live' : ' Inactive')), onChange: handleCheckboxToggle })) }))));
    }
    function renderMainCard() {
        return (react_1.default.createElement(polaris_1.Card, null,
            react_1.default.createElement(polaris_1.BlockStack, { gap: '300' },
                react_1.default.createElement(polaris_1.FormLayout, null,
                    react_1.default.createElement(react_hook_form_1.Controller, { control: control, name: 'subject', render: (_a) => {
                            var _b;
                            var _c = _a.field, { value, ref: _ref } = _c, rest = __rest(_c, ["value", "ref"]);
                            return (react_1.default.createElement(polaris_1.TextField, Object.assign({}, rest, { autoComplete: 'off', error: (_b = errors.subject) === null || _b === void 0 ? void 0 : _b.message, id: 'email-template-subject-line', inputMode: 'text', label: 'Subject line', maxLength: 100, showCharacterCount: true, type: 'text', value: value ? value : undefined })));
                        } }),
                    renderBannerUploadArea(),
                    react_1.default.createElement(react_hook_form_1.Controller, { control: control, name: 'imageBannerLink', render: (_a) => {
                            var _b;
                            var _c = _a.field, { value, ref: _ref } = _c, rest = __rest(_c, ["value", "ref"]);
                            return (react_1.default.createElement(polaris_1.TextField, Object.assign({}, rest, { autoComplete: 'off', error: (_b = errors.imageBannerLink) === null || _b === void 0 ? void 0 : _b.message, helpText: email_template_copy_1.EMAIL_TEMPLATE_COPY.imageUploadLinkHelpText, id: 'email-template-image-banner-link', inputMode: 'text', label: 'Image banner link', placeholder: 'Enter a valid URL', type: 'text', value: value ? value : undefined })));
                        } }),
                    react_1.default.createElement(react_hook_form_1.Controller, { control: control, name: 'heading', render: (_a) => {
                            var _b;
                            var _c = _a.field, { value, ref: _ref } = _c, rest = __rest(_c, ["value", "ref"]);
                            return (react_1.default.createElement(polaris_1.TextField, Object.assign({}, rest, { autoComplete: 'off', error: (_b = errors.heading) === null || _b === void 0 ? void 0 : _b.message, id: 'email-template-heading', inputMode: 'text', label: 'Heading', maxLength: 200, showCharacterCount: true, type: 'text', value: value ? value : undefined })));
                        } }),
                    react_1.default.createElement(react_hook_form_1.Controller, { control: control, name: 'body', render: (_a) => {
                            var _b;
                            var _c = _a.field, { value, ref: _ref } = _c, rest = __rest(_c, ["value", "ref"]);
                            return (react_1.default.createElement(polaris_1.TextField, Object.assign({}, rest, { autoComplete: 'off', error: (_b = errors.body) === null || _b === void 0 ? void 0 : _b.message, helpText: react_1.default.createElement(components_1.MarkdownMessage, null), id: 'email-template-body', inputMode: 'text', label: 'Body', maxLength: 600, multiline: 1, showCharacterCount: true, type: 'text', value: value ? value : undefined })));
                        } }),
                    renderVariablesArea(),
                    react_1.default.createElement(react_hook_form_1.Controller, { control: control, name: 'footer', render: (_a) => {
                            var _b;
                            var _c = _a.field, { value, ref: _ref } = _c, rest = __rest(_c, ["value", "ref"]);
                            return (react_1.default.createElement(polaris_1.TextField, Object.assign({}, rest, { autoComplete: 'off', error: (_b = errors.footer) === null || _b === void 0 ? void 0 : _b.message, helpText: react_1.default.createElement(components_1.MarkdownMessage, null), id: 'email-template-footer', inputMode: 'text', label: 'Footer text', maxLength: 200, showCharacterCount: true, type: 'text', value: value ? value : undefined })));
                        } })))));
    }
    function renderVariablesArea() {
        const variables = [
            'shop_name',
            'order_name',
            'first_name',
            'last_name',
            'reply_to_email'
        ];
        return (react_1.default.createElement("span", { id: 'email-template-variables-section' },
            react_1.default.createElement(polaris_1.BlockStack, { gap: '300' },
                react_1.default.createElement(polaris_1.InlineStack, { gap: '100' },
                    react_1.default.createElement(polaris_1.Text, { as: 'h3' }, "Variables"),
                    react_1.default.createElement(components_1.IconTooltip, { content: react_1.default.createElement(polaris_1.InlineStack, { gap: '200' },
                            react_1.default.createElement(polaris_1.Text, { as: 'p' }, email_template_copy_1.EMAIL_TEMPLATE_COPY.variablesTooltipText)) })),
                react_1.default.createElement(polaris_1.BlockStack, { gap: '200' }, variables.map((item) => (react_1.default.createElement("span", { key: `${item}-variable` },
                    react_1.default.createElement(polaris_1.InlineStack, null,
                        react_1.default.createElement(text_1.Highlight, null, `{{${item}}}`)))))))));
    }
    function renderBannerUploadArea() {
        return (react_1.default.createElement(polaris_1.BlockStack, { gap: '300' },
            react_1.default.createElement(components_1.ImageUpload, { dropZoneHintText: email_template_copy_1.EMAIL_TEMPLATE_COPY.imageUploadDropZoneText, existingImageUrl: imageBannerUrl, handleImageUpload: handleImageUpload, handleRemoveImageUrl: handleRemoveImageUrl, helpText: email_template_copy_1.EMAIL_TEMPLATE_COPY.imageUploadHelpText, label: 'Image banner', maxFileSizeKB: 1000, name: 'email-template-banner-image-upload', onlyAllowImageTypes: ['image/png', 'image/jpeg'], uploadError: imageUploadError })));
    }
};
exports.EmailTemplate = EmailTemplate;
